import {filter} from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';
import {OAuthService, AuthConfig, JwksValidationHandler} from 'angular-oauth2-oidc';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../environments/environment';

import _ from 'lodash';

@Component({
  selector: 'app-login-router',
  templateUrl: './login-router.component.html',
  styles: [],
  standalone: true
})
export class LoginRouterComponent implements OnInit {
  private envConf: any;
  public token: any;

  constructor(private oauthService: OAuthService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.envConf = this.route.snapshot.data['environment'];
    environment.auth.active = Object.assign({}, this.envConf); // set the active environment configuration
    sessionStorage.setItem('auth', this.envConf);
    sessionStorage.setItem('auth', JSON.stringify(this.envConf));
    this.configureAuth();
    this.oauthService.tryLogin({
      onTokenReceived: context => {
        console.log('Logged in', context);
      },
      onLoginError: context => {
        console.log('Login error', context);
      }
    }).then(() => {
      if (!this.isLoggedIn()) {
        this.oauthService.logOut();
        console.log('not logged in');
        this.configureAuth();
      } else {
        this.triggerAutoRefresh();
      }
    });
  }

  private configureAuth() {
    this.oauthService.setStorage(sessionStorage);

    const authConfig: AuthConfig = {
      issuer: this.envConf.issuer,
      redirectUri: this.envConf.redirectUrl,
      clientId: this.envConf.appID,
      scope: this.envConf.scope,
      oidc: this.envConf.oidc,
      silentRefreshRedirectUri: environment.baseUrl + 'silent-refresh.html',
      strictDiscoveryDocumentValidation: false,
      sessionChecksEnabled: true,
      sessionCheckIntervall: 1000 * 3600,
      showDebugInformation: true
    };

    this.oauthService.configure(authConfig);
    this.oauthService.setupAutomaticSilentRefresh();
    // this.oauthService.tokenValidationHandler = new JwksValidationHandler();

    this.oauthService.events.subscribe(e => {
      console.debug('oauth/oidc event', e);
    });

    // Load Discovery Document and then try to login the user
    this.oauthService.loadDiscoveryDocument(this.envConf.discovery)
      .then((doc) => {
        this.oauthService.tryLogin().catch(e => {
          console.error('Auth error occured', e);
        });
        const claims = this.oauthService.getIdentityClaims();
        this.token = this.oauthService.getAccessToken();
        window.sessionStorage.auth = JSON.stringify(this.envConf);

        if (!this.token) {
          // redirect to auth server
          // this.oauthService.initImplicitFlow('', { acr_values: 'idp:aadfed tenant:internal_crumbs' });
          this.oauthService.initImplicitFlow('', {acr_values: _.get(this.envConf, 'acrValues', '')});
          console.log('redirect to auth server');
        } else {
          // load user details using the retrieved token from auth server
          console.log('got the token');

          if (localStorage.getItem('redirectTo')) {
            // redirect to the page before being forced to login
            const redirectUrl = localStorage.getItem('redirectTo');
            console.log('redirecting to...', redirectUrl);
            localStorage.removeItem('redirectTo');
            setTimeout(() => {
              this.router.navigateByUrl(redirectUrl);
            }, 500); // added timeout before redirecting
          } else {
            // redirect to home
            this.router.navigate(['/']);
          }

        }
      });

    this.oauthService.events.pipe(filter(e => e.type === 'token_expires'))
      .subscribe(e => {
        console.debug('received token_expires event', e);
        this.oauthService.silentRefresh()
          .then(info => console.debug('refresh ok', info))
          .catch(err => console.error('refresh error', err));
      });
  }


  public isLoggedIn(): boolean {
    const claims = this.oauthService.getIdentityClaims();
    if (claims) {
      if (this.oauthService.hasValidAccessToken()) {
        console.log('valid token');
      } else {
        this.oauthService.logOut();
      }
      return true;
    } else {
      return false;
    }
  }

  public triggerAutoRefresh() {
    console.log('Trigger auto refresh...');
    // refresh every <minutes> minutes
    const minutes = 1;
    setInterval(() => {
      this.oauthService.silentRefresh().then(() => {
        console.log('silent refresh successful');
      }).catch(err => console.error('refresh error', err));
    }, minutes * 60 * 1000);
  }
}
